import { render } from "./CursorTooltip.vue?vue&type=template&id=32ac60c1&scoped=true"
import script from "./CursorTooltip.vue?vue&type=script&lang=js"
export * from "./CursorTooltip.vue?vue&type=script&lang=js"

import "./CursorTooltip.vue?vue&type=style&index=0&id=32ac60c1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ac60c1"]])

export default __exports__